<app-map
  #map
  [markers]="markers"
  [useMarkerCluster]="true"
  [isFullscreenButtonVisible]="false"
  (markerClicked)="openPopup($event)"
></app-map>
